import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

export default function Field({ title, children }) {
  return (
    <Row className="py-3">
      <Col md="3" className="fw-light">
        {title}
      </Col>

      <Col md="9" className="text-md-end text-muted text-truncate">
        {children}
      </Col>
    </Row>
  );
}

Field.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
